const PollBadge = ({ values = {}, partyMetaMap = new Map, max = 0 }) => {
    console.log("🚀 ~ PollBadge ~ partyMetaMap:", partyMetaMap)
    console.log("🚀 ~ PollBadge ~ values:", values)
    const parties = Object.keys(values);
    // console.log('values', partyMetaMap)
    // console.log('values', values)
    // Array.sort()
    parties?.sort()
    console.log('parties', parties)
    return (
        <div className={`overflow-x-auto  ${parties.length > 8 ? 'w-[30rem]' : 'w-[26rem]'}`}>
            <table className="min-w-full">
                <tbody>
                    <tr className="flex items-baseline">
                        <td className="flex-1 py-1 px-2">
                            {parties.length > 0 ? (
                                <div
                                    className="grid gap-2 divide-x divide-transparent"
                                    style={{ gridTemplateColumns: `repeat(${parties.length}, minmax(0, 1fr))` }}
                                >
                                    {parties.map((party) => {
                                        const value = values[party];
                                        const meta = partyMetaMap.get(party?.toUpperCase()) ?? {};
                                        const bgColor = meta?.color ?? "#ccc";
                                        const textColor = meta.color === "#FFFF00" ? "#000" : "#fff";
                                        const icon = meta.icon;

                                        return (
                                            <div key={party} className="flex flex-col items-center space-y-1">
                                                <button
                                                    style={{ backgroundColor: bgColor, color: textColor }}
                                                    className={`text-xs p-1 px-2 shadow-md w-12 text-center`}
                                                >
                                                    {value ?? 0}
                                                </button>
                                            </div>
                                        );
                                    })}

                                </div>
                            ) : (
                                <div className="text-gray-400">No Data</div>
                            )}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
};

export default PollBadge;

